export default __webpack_public_path__ + "static/media/complete-arrow-left.57adc098.svg";